<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="media">
          <div class="media-left">
            <figure class="image is-48x48">
              <font-awesome-icon
                v-if="getIcon().type === 'fontawesome'"
                class="apps-icon"
                :icon="getIcon().icon"
              ></font-awesome-icon>
              <svg class="app-icon" v-if="getIcon().type === 'svg'">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="`#${getIcon().icon}`"></use>
              </svg>
            </figure>
          </div>
          <div class="media-content">
            <p class="title is-4">
              <strong>{{ getTitle() }}</strong>
            </p>
            <p class="subtitle is-6">{{ getSubtitle() }}</p>
          </div>
        </div>
        <button class="delete" aria-label="close" @click="close()"></button>
      </header>
      <section class="modal-card-body">
        <div v-if="!currentApp">
          <CapableAppSelection :capableApps="capableApps" @selected="onAppSelected" />
        </div>
        <div v-if="currentApp">
          <CapableAppConfig :installedApp="currentApp" :configRequest="configRequest" @configured="complete" />
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { InstalledApp, AppConfigViewModel } from '@/features/apps/shared/models';
import CapableAppSelection from './CapableAppSelection.vue';
import CapableAppConfig from './CapableAppConfig.vue';
import { ConfigRequest } from './configRequest';
import { PropType, ref } from 'vue';

const props = defineProps({
  capableApps: {
    type: Array as PropType<InstalledApp[]>,
    required: true,
  },
  configRequest: {
    type: Function as PropType<
      (workspaceId: string, installedAppId: string, values: any, storedData: any, componentId: any) => Promise<any>
    >,
    required: true,
  },
  modalHeading: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'completed', installedAppId: string, config: any): void;
  (e: 'close'): void;
}>();

const currentApp = ref<InstalledApp | null>(null);

function getTitle() {
  if (currentApp.value) {
    return currentApp.value.name;
  }
  return props.modalHeading;
}

function getSubtitle() {
  if (currentApp.value) {
    if (currentApp.value.description) {
      return currentApp.value.description;
    }
    return 'Private app';
  }
  return 'Select from your installed apps';
}

function getIcon() {
  if (!currentApp.value) {
    return { type: 'fontawesome', icon: 'cubes' };
  }
  if (currentApp.value.icon) {
    return { type: 'svg', icon: currentApp.value.icon };
  }
  return { type: 'fontawesome', icon: 'code' };
}

function close() {
  emit('close');
}

function onAppSelected(app: InstalledApp) {
  if (app.hasConfigUrl) {
    currentApp.value = app;
  } else {
    complete(app.installedAppId, {});
  }
}

function complete(installedAppId: string, config: any) {
  emit('completed', installedAppId, config);
  close();
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  .delete {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }
}

.columns {
  flex: 1;
}

.column:first-of-type {
  border-right: 1px solid #dbdbdb;
}

.modal-card {
  // width: 50%;
  // height: 70%;
  width: 540px;
  height: 640px;
}

.modal-card-body {
  display: flex;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.modal-card-body {
  display: flex;
  flex-direction: column;
}

.install-actions {
  margin-bottom: 2rem;

  .button {
    width: 100%;
  }
}

.app-links {
  .title {
    margin-bottom: 1rem;
  }
}

.is-48x48 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.apps-icon {
  width: 3rem;
  height: 3rem;
  color: $color-netcall-deep-sea;
}

.app-icon {
  width: 3rem;
  height: 3rem;
}

.circle-image {
  background-color: white;
  border-radius: 99em;
  width: 3em;
  height: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  * {
    width: 100%;
    height: 100%;
  }
}
</style>
